import { createConsola as o } from "consola";
import { createContext as n } from "unctx";
const r = n();
function g(t) {
  const e = o().withTag(t);
  return r?.set(e), e;
}
function u(t) {
  try {
    return r?.use();
  } catch {
    return g(t);
  }
}
export {
  u as default
};
